import { useQueryMe } from '@/services/auth/queries'
import { BusinessSubscription } from '@/types/org'
import { UsageRecord } from '@/types/user'
import { createContext } from 'react'
import { useAuthContext } from '.'

/* eslint-disable react-refresh/only-export-components -- context module */

export type SubscriptionContextDefaultProps = {
    subscription: BusinessSubscription | undefined
    usage_record: UsageRecord | undefined
}

const defaultValues: SubscriptionContextDefaultProps = {
    subscription: undefined,
    usage_record: undefined,
}

export const SubscriptionContext = createContext(defaultValues)

export default function SubscriptionContextProvider({ children }: { children: React.ReactNode }) {
    const { loggedIn } = useAuthContext()

    const { data } = useQueryMe({ enabled: !!loggedIn })

    return (
        <SubscriptionContext.Provider value={{ subscription: data?.subscription, usage_record: data?.usage_record }}>
            {children}
        </SubscriptionContext.Provider>
    )
}
